<template>
  <div>
    <van-dialog
      v-model="isTelShow"
      title="输入手机号绑定账号"
      :before-close="onBeforeClose"
      @confirm="confirm"
      show-cancel-button
    >
      <van-field
        v-model="tel"
        type="digit"
        label="手机号码"
        placeholder="请输入手机号码"
      />
    </van-dialog>
  </div>
</template>

<script>
import api from "../../common/js/api";
import config from "../../common/js/config";
export default {
  data() {
    return {
      isTelShow: true,
      tel: "",
      code: "",
    };
  },

  components: {},

  computed: {},

  created() {
    var openId = localStorage.getItem("openId");
    if (!openId) {
      let code = this.getUrlKey("code"); //获取url参数code
      if (!code) {
        this.getCodeApi("0");
      } else {
        this.code = code;
      }
    } else {
      this.$router.push("/merchantBind");
    }
  },

  mounted() {},

  methods: {
    getUrlKey(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getCodeApi(state) {
      let urlNow = encodeURIComponent(window.location.href);
      let scope = "snsapi_base"; //snsapi_userinfo   //静默授权 用户无感知
      let appid = config.AppId;
      let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${urlNow}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
      window.location.replace(url);
    },
    //输入密码弹窗关闭前的事件
    onBeforeClose(action, done) {
      if (action === "confirm") {
        return done(false);
      } else {
        return done();
      }
    },
    confirm() {
      if (this.tel === "") {
        this.$toast("请输入手机号码");
      } else {
        this.$post(api.auth, { code: this.code, state: this.tel }).then(
          (res) => {
            if (res.data.message == "1") {
              var openId=res.data.openId.toString();
              localStorage.setItem("openId",openId);
              this.$router.push("/merchantBind");
            } else {
              this.$toast(res.data.message);
            }
          }
        );
      }
    },
  },
};
</script>
<style lang='scss' scoped>
</style>